module.exports = __webpack_public_path__ + "img/arrow_up_green_24dp@2x.526b6b9b.png";